// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ne-0";